import * as React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { AddCircleOutline, RemoveCircleOutline } from '@mui/icons-material';

export default function RepeatDiscountSlider({ min, max, value, onChange }) {
  const currentValue = typeof value === 'number' && value >= min && value <= max ? value : min;

  const increaseValue = () => {
    if (currentValue < max) {
      onChange(currentValue + 1);
    }
  };

  const decreaseValue = () => {
    if (currentValue > min) {
      onChange(currentValue - 1);
    }
  };

  return (
    <Box sx={{ width: 250 }}>
              <h4>Repeat Discount</h4>

      <Grid className='commission_input' container spacing={2} alignItems="center">
      <div>
          <IconButton onClick={increaseValue} disabled={currentValue >= max}>
            <AddCircleOutline style={{color:'#8F8F8F'}} color='#8F8F8F' />
          </IconButton>
        </div>

          <p style={{ margin: 0, textAlign: 'center' }}>{currentValue}</p>

          <div>
          <IconButton onClick={decreaseValue} disabled={currentValue <= min}>
            <RemoveCircleOutline style={{color:'#8F8F8F'}} />
          </IconButton>
        </div>
      </Grid>
    </Box>
  );
}
